<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 101 193"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <path
            class="fil0 str1"
            d="M28 146l48 0c0,-1 0,-22 0,-23 0,-1 -1,-1 -2,-2 0,-1 0,-2 0,-3 0,-1 0,-3 0,-4 0,-1 0,-2 0,-3 0,-1 1,-1 2,-2 1,0 2,-2 2,-3 0,-1 -3,-3 -4,-4 0,0 -1,-1 -1,-2 0,-1 0,-2 0,-3 0,-1 0,-2 1,-2 1,-1 4,-3 4,-5 0,-1 -3,-2 -4,-3 0,0 0,-1 0,-1 0,0 0,-1 0,-2 0,0 0,-1 0,-1 0,-1 0,-1 0,-2 0,-1 0,-1 0,-1 1,-2 4,-2 4,-5 0,-1 -4,-3 -4,-5 0,-1 0,-3 0,-4 0,-2 4,-3 4,-5 0,-4 -4,-4 -4,-9 0,-4 3,-4 3,-7 0,-3 -10,-15 -14,-18l-20 0c-2,1 -6,3 -8,5 -3,3 -4,8 -4,12 0,4 -5,5 -5,8 0,2 4,3 4,7 0,6 -4,6 -4,9 0,2 4,3 4,5 0,1 0,3 0,4 0,2 -4,4 -4,5 0,3 3,3 4,5 0,1 0,6 0,7 -1,1 -4,2 -4,3 0,2 3,3 4,5 1,1 1,5 0,6 -1,1 -3,3 -3,4 0,1 4,4 5,5 0,1 -3,2 -3,3 0,1 0,22 0,23zm48 -102c-13,1 -32,3 -47,7m46 8c-13,1 -31,3 -46,6m45 8c-12,1 -30,3 -45,6m44 8c-13,1 -30,3 -44,6m45 -43c-13,1 -31,3 -46,7m46 8c-13,1 -32,3 -47,7m46 8c-14,1 -32,3 -46,7m46 8c-15,1 -32,3 -47,7m46 0c-13,1 -29,3 -45,6m45 1c-13,1 -31,3 -46,7"
        />
        <path
            class="filWhite str1"
            d="M50 137c14,0 27,-1 35,5 5,4 6,16 6,22 0,7 1,15 -6,19 -4,3 -10,2 -16,3 -6,1 -11,3 -18,4 -10,0 -13,-2 -24,-2 -9,0 -15,-10 -17,-16 0,-9 -3,-27 3,-33 14,0 26,-2 35,-2z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
